<script lang="ts">
  import ProductContent from '$lib/components/product/ProductContent.svelte'
  import ProductData from '$lib/components/product/ProductData.svelte'
  import StructuredData from '$lib/components/common/StructuredData.svelte';
  import { storeVisitedProducts } from '$lib/js/stores'
  import { containsProduct, is_set_object, isSequraActive } from '$lib/js/helpers';
  import { getBreadcrumbsSchema, getMerchantSchema } from "$lib/js/structured_data";
  import { page } from '$app/state';
  import { afterNavigate, beforeNavigate } from '$app/navigation';
  import { registerViewItemEvent } from '$lib/js/ga4/events';
  import { getContextScope } from '$lib/js/helpers/i18n'
	import { sendWT3 } from '$lib/js/helpers/wt3'

  const scope = getContextScope()

  let innerWidth = $state(0);
  let product = $derived(page.data.product)

  beforeNavigate(() => {
    if(containsProduct(product, $storeVisitedProducts) === false) {
      $storeVisitedProducts.unshift(product)

      if($storeVisitedProducts.length >= 9) {
        $storeVisitedProducts = $storeVisitedProducts.slice(0, 8)
      }

      $storeVisitedProducts = $storeVisitedProducts
    }
  })

  afterNavigate(async () => {
    if(isSequraActive(page.data?.settings, product?.category_ids)) {
      window.Sequra.onLoad(function () {
        window.Sequra.refreshComponents();
      });
    }
    registerViewItemEvent(page.data.product, page.data.brand)

		sendWT3(
      "view_item",
      {product})
  })
</script>

<StructuredData schema={getMerchantSchema(page.data.product, {brand: page.data.brand, reviews: page.data.reviews, scope: scope})}/>

{#if is_set_object(page.data.product.category)}
  <StructuredData schema={getBreadcrumbsSchema(page.data.product.category)}/>
{/if}

<svelte:head>
  {#if isSequraActive(page.data?.settings)}
    {#if scope === "fr"}
      <script>window.sequra_locale = "fr-FR"</script>
    {:else if scope === "es"}
      <script>window.sequra_locale = "es-ES"</script>
    {:else}
      <script>window.sequra_locale = "en-US"</script>
    {/if}

    <script>
      var sequraConfigParams = {
        merchant: "bixoto",
        assetKey: "McY_O5ODVg",
        products: ["pp3"],
        scriptUri: "https://live.sequracdn.com/assets/sequra-checkout.min.js",
        decimalSeparator: ".",
        locale: window.sequra_locale,
        currency: "EUR",
      };

      (function(i, s, o, g, r, a, m) {i["SequraConfiguration"] = g;i["SequraOnLoad"] = [];i[r] = {};i[r][a] = function(callback) {i["SequraOnLoad"].push(callback);};(a = s.createElement(o)), (m = s.getElementsByTagName(o)[0]);a.async = 1;a.src = g.scriptUri;m.parentNode.insertBefore(a, m);})(window, document, "script", sequraConfigParams, "Sequra", "onLoad");
    </script>
  {/if}
</svelte:head>

<svelte:window bind:innerWidth />


{#key product}
  <div class="container-special">
    <div class="product-info">
      <div class="container-special">

        <div class="product-info__inner">
          <div class="product-info__left">
            <ProductContent {product}/>
          </div>

          {#if page.data.mobile === false || innerWidth > 768}
            <div class="product-info__content">
              <ProductData {product} />
            </div>
          {/if}
        </div>
      </div>
    </div>
  </div>
{/key}


<style lang="scss">
  .container-special {
    max-width: 1440px;
    margin: 0 auto 100px;
  }

  .product-info {
    &__inner {
      position: relative;

      @media (min-width: 769px) {
        display: flex;
        flex-wrap: wrap;
        justify-content: space-between;
      }
    }

    &__left {
      @media (min-width: 769px) {
        width: calc(100% - 340px);
      }

      @media (min-width: 1201px) {
        width: calc(100% - 415px);
      }
    }

    &__content {
      height: calc(100vh - 100px);

      @media (max-width: 768px) {
        display: none;
      }

      @media (min-width: 769px) {
        position: sticky;
        right: 0;
        top: 100px;
        bottom: 0;
        width: 340px;
      }

      @media (min-width: 1201px) {
        width: 415px;
      }
    }
  }
</style>
